import CheckboxModule from './checkbox.module'

export default CheckboxModule
